import { Carousel } from 'bootstrap'

window.addEventListener('load', ()=> {
  if ('ontouchstart' in window) {
    document.querySelector('html').classList.add('touch-available')
  } else {
    document.querySelector('html').classList.add('touch-not-available')
  }
})

window.onscroll = ()=> {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop
  if (scrollTop === 0) {
    document.body.classList.remove('scrolled')
  } else {
    document.body.classList.add('scrolled')
  }
}

document.addEventListener('turbolinks:load', ()=> {
  let external_links = document.querySelectorAll('a[rel=external]')
  Array.prototype.forEach.call(external_links, (link, i)=>{
    link.addEventListener('click', (event)=> {
      event.preventDefault()
      window.open(link.getAttribute('href'))
    })
  })
})

document.addEventListener('turbolinks:load', ()=> {
  let products = document.querySelectorAll('section.products .product')
  let bs_carousels = {}
  let carousel_intervals = {}
  products.forEach((product)=>{
    let picture_element = product.querySelector('.pictures')
    let carousel_element = picture_element.querySelector('.carousel')
    if (carousel_element) {
      bs_carousels[carousel_element.id] = new Carousel(carousel_element, { interval: false })
      product.addEventListener('mouseenter', (event)=> {
        bs_carousels[carousel_element.id].next()
        carousel_intervals[carousel_element.id] = setInterval(()=>{
          bs_carousels[carousel_element.id].next()
        }, 3000)
      })
      product.addEventListener('mouseleave', (event)=> {
        clearInterval(carousel_intervals[carousel_element.id])
      })
    }
  })
})
